const {Static2} = require("./static-2");
const {cs} = require("./chain-services");
const {createEventEmitter} = require("./event");

const LocalEvent = ({next}) => cs(["events", (_, next) => Static2({next, getInitValue: createEventEmitter})], ({events}) => next(events.get()));

exports.LocalEvent = LocalEvent;
